import config from '../config/config';
import axios from 'axios';
import { getAuthHeader, getAnonymousURL } from '../utils/service-utils';

const API_GATEWAY_URL_V2 = config.api.apiGatewayUrlV2;

export async function getApis(auth, pageSize = 500) {
  const endpointUrl = getAnonymousURL(auth, API_GATEWAY_URL_V2);
  const headers = getAuthHeader(auth);

  const { data } = await axios({
    method: 'GET',
    url: `${endpointUrl}/directory`,
    params: {
      view: 'combined',
      page: 1,
      pageSize
    },
    headers: { ...headers }
  });

  if (!data || typeof data !== 'object') {
    return data;
  }

  const totalPages = data.totalPages || 1;
  let allItems = Array.isArray(data.items) ? [...data.items] : [];
  let allBundles = Array.isArray(data.bundles) ? [...data.bundles] : [];

  if (totalPages > 1) {
    const pageRequests = [];
    for (let page = 2; page <= totalPages; page++) {
      pageRequests.push(
        axios({
          method: 'GET',
          url: `${endpointUrl}/directory`,
          params: {
            view: 'combined',
            page,
            pageSize
          },
          headers: { ...headers }
        })
      );
    }

    const responses = await Promise.all(pageRequests);
    responses.forEach(res => {
      if (res?.data?.items && Array.isArray(res.data.items)) {
        allItems = allItems.concat(res.data.items);
      }
      if (res?.data?.bundles && Array.isArray(res.data.bundles)) {
        res.data.bundles.forEach(bundle => {
          if (bundle?.id && !allBundles.some(b => b.id === bundle.id)) {
            allBundles.push(bundle);
          } else if (!bundle?.id) {
            allBundles.push(bundle);
          }
        });
      }
    });
  }

  return {
    ...data,
    items: allItems,
    bundles: allBundles
  };
}

export async function getGroups(auth) {
  const { isAuthenticated } = auth;
  const endpointUrl = getAnonymousURL(auth, API_GATEWAY_URL_V2);
  const urlPart = isAuthenticated ? '/directory/groups' : '/v1/domains';

  const { data } = await axios({
    method: 'GET',
    url: `${endpointUrl}${urlPart}`,
    headers: { ...getAuthHeader(auth) }
  });

  return data;
}

export async function getUserProfile(auth) {
  const uid = auth?.userData?.sub || auth?.sub || auth?.userData?.uid;
  const accountsUrl = (config.accountsServer?.url || '').replace(/\/$/, '');
  if (!uid || !accountsUrl) return null;

  const { data } = await axios({
    method: 'GET',
    url: `${accountsUrl}/api/v1/users/profile/${uid}`,
    headers: { ...getAuthHeader(auth) }
  });

  return data;
}

